module.exports = __webpack_public_path__ + "static/media/dcbLogo.7328f4aa.svg";